import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "form", "container", "newStepButton", "removeStepButton",
    "followUpDelay", "subjectLine", "unsubscribeCheckbox",
    "unsubscribeCheckboxLabel", "unsubscribeLinkAlert", "unsubscribeLinkStatus"
  ]

  static values = {
    steps: Number,
    campaignId: Number,
    isCampaignActive: Boolean,
    maxFollowUps: Number,
  }

  connect() {
    // When the campaign is not editable, there's no button
    if (this.hasNewStepButtonTarget) {
      if (this.isCampaignActiveValue === true) {
        App.tooltip(this.newStepButtonTarget, { title: i18n.t("js.back.campaigns.content.pause_campaign_first"), placement: "top" })
        this.newStepButtonTarget.classList.add("disabled")
        return
      }

      if (this.stepsValue === this.maxFollowUpsValue) {
        App.tooltip(this.newStepButtonTarget, { title: i18n.t("js.back.campaigns.content.max_number_follow_ups_reached", { count: this.maxFollowUpsValue - 1 }), placement: "top" })
        this.newStepButtonTarget.classList.add("disabled")
      }
    }
  }

  addFollowUp() {
    if (this.isCampaignActiveValue || this.stepsValue >= this.maxFollowUpsValue) {
      return
    }

    // All the buttons to remove the follow ups are removed.
    this.removeStepButtonTargets.forEach(function (target) {
      target.classList.add("d-none")
    })

    const formData = {
      follow_up: {
        step: this.stepsValue,
        wait_days: 3,
      }
    }

    fetch(`/campaigns/${this.campaignIdValue}/follow-ups/${this.stepsValue}`, {
      credentials: "same-origin",
      headers: {
        'Content-Type': 'application/json',
        "Email-Hunter-Origin": "followup_editor",
        "X-CSRF-Token": $("meta[name='csrf-token']").attr("content"),
      },
      method: "POST",
      body: JSON.stringify(formData),
    }).then(() => {
      this.stepsValue = this.stepsValue + 1

      // Users can't create an unlimited number of steps.
      if (this.stepsValue >= this.maxFollowUpsValue) {
        App.tooltip(this.newStepButtonTarget, { title: i18n.t("js.back.campaigns.content.max_number_follow_ups_reached", { count: this.maxFollowUpsValue - 1 }), placement: "top" })
        this.newStepButtonTooltip = bootstrap.Tooltip.getOrCreateInstance(this.newStepButtonTarget)
        this.newStepButtonTooltip.enable()
        $(this.newStepButtonTarget).addClass("disabled")
      }
    })
  }

  deleteFollowUp() {
    this.stepsValue = this.stepsValue - 1

    if (this.stepsValue < this.maxFollowUpsValue) {
      this.newStepButtonTooltip = bootstrap.Tooltip.getOrCreateInstance(this.newStepButtonTarget)
      this.newStepButtonTooltip.disable()
      $(this.newStepButtonTarget).removeClass("disabled")
    }

    const previousFollowUpButton = this.removeStepButtonTargets.length - 2

    if (previousFollowUpButton >= 0 && this.removeStepButtonTargets[previousFollowUpButton]) {
      this.removeStepButtonTargets[previousFollowUpButton].classList.remove("d-none")
      this.removeStepButtonTargets[previousFollowUpButton].dataset.action = "click->campaign--add-follow-ups#deleteFollowUp click->campaign--follow-up#deleteFollowUp"

    }
  }
}
